import dayjs from "../../../utils/dayjs";
function getDateString(date) {
  return dayjs(date).format("YYYY-MM-DD");
}
export {
  getDateString as default
};
